import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import Form from '../form/form';
import GoogleMap from '../../components/maps';
import Container from '../../components/container';

export const query = graphql`
  fragment FormMapsBlock on MarkdownRemarkFrontmatterBlocks {
    template
    form {
      frontmatter {
        ...FormFrontmatter
      }
    }
  }
`;

const FormMaps = ({
  className,
  // template,
  form,
}) => (
  <Container>
    <div className={className}>
      <FormWrapper>
        <Form
          form={form}
          template="withTitle"
        />
      </FormWrapper>

      <MapsWrapper>
        <GoogleMap
          template="contact"
        />
      </MapsWrapper>
    </div>
  </Container>
);


const FormWrapper = styled.div`
  order: 2;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    order: 1;
  }
`;

const MapsWrapper = styled.div`
  margin-left: -${(props) => props.theme.grid.containerGap};
  margin-right: -${(props) => props.theme.grid.containerGap};
  margin-bottom: 3rem;
  order: 1;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    margin-left: 0;
    margin-right: -16.66667%;
    margin-bottom: 0;
    order: 2;
  }
`;

export default styled(FormMaps)`
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;
  grid-gap: 0 12rem;
  padding-bottom: ${(props) => props.theme.sectionSpace};
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    grid-template-columns: 2fr 3fr;
  }
`;
